import React from "react";

export default function SparkleIcon({className}) {
    return (
        <svg className={className} viewBox="0 0 32 39" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 39C16 33.5636 17.5515 28.9545 20.6545 25.1727C23.7576 21.3909 27.5394 19.5 32 19.5C27.5394 19.5 23.7576 17.6091 20.6545 13.8273C17.5515 10.0455 16 5.43636 16 0C16 5.43636 14.4485 10.0455 11.3455 13.8273C8.24243 17.6091 4.46061 19.5 0 19.5C4.46061 19.5 8.24243 21.3909 11.3455 25.1727C14.4485 28.9545 16 33.5636 16 39Z"
                fill="currentColor"/>
        </svg>
    )
}
